import Grid from "@mui/material/Grid2";
import { RefineListView } from "@/components";
import { MonthlyOrdersChart } from "@/components/dashboard/ordersPlaced/MonthlyOrdersChart";
import { OrderStatusMetricsChart } from "@/components/dashboard/ordersPlaced/OrderStatusMetricsChart";
import { StatusAnalytics } from "@/components/dashboard/statCard/StatusBasedNumberCards";
import { Stack } from "@mui/material";
import { PersonOutlineOutlined } from "@mui/icons-material";
import SareeIcon from "@/assests/icons/SareeIcon";

export const DashboardPage: React.FC = () => {
  return (
    <RefineListView
    >
      <Stack direction="row" spacing={2} width="100%" mb={2}>
        <StatusAnalytics resource="analytics/accounts" title="User Status Analytics" devideBy12={4} icon={<PersonOutlineOutlined />} />
        <StatusAnalytics resource="analytics/products" title="Product Stock Analytics" devideBy12={3} icon={<SareeIcon />} />
      </Stack>
      <Grid container columns={24} spacing={3} mb={2}>       
        <Grid
          size={{
            xs: 24,
            sm: 24,
            md: 24,
            lg: 48,
            xl: 48,
          }}
          sx={{
            height: "504px",
          }}
        >
          <MonthlyOrdersChart />
        </Grid>
        <Grid
          size={{
            xs: 24,
            sm: 24,
            md: 24,
            lg: 48,
            xl: 48,
          }}
          sx={{
            height: "504px",
          }}
        >
          <OrderStatusMetricsChart />
        </Grid>       
      </Grid>
    </RefineListView>
  );
};
